// ======================================================================
// File Name       : AboutSuperuserServiceRoleDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React from 'react';
import { Modal, Button, Table, Col, Form } from 'react-bootstrap';
import { HYPHEN, MESSAGE_TYPE, MODAL_SIZE } from '../../constants/index';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';

class AboutSuperuserServiceRoleDialog extends React.Component {
  /**
   * Get authority text by number
   * @param {number} authority
   * @return {string}
   */
  getAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '参照のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  /**
     * Get scoring authority text by number
     * @param {number} authority
     * @return {string}
     */
  getScoringAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '採点のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  getAuthorityDisplayText(authority) {
    switch (authority) {
      case 0:
        return '非表示';
      case 1:
      case 2:
        return '表示';
      default:
        return '';
    }
  }

  getMaterialAuthorityText(authority) {
    switch (authority) {
      case 1:
        return 'ダウンロード可';
      default:
        return HYPHEN;
    }
  }

  render() {
    const {
      showModal,
      onAuthorityAboutOk,
      showDialogRoleSecernId,
      superuserAllServiceRoleList,
    } = this.props;

    const style = {
      background: 'none',
      width: 'auto',
      height: 'auto',
      marginLeft: 0,
      left: 0,
    };

    const superuserServiceRole = superuserAllServiceRoleList.bySecernId[showDialogRoleSecernId];
    const authorityDisplayMapping = Object.keys(superuserServiceRole.managementFunctionAuthorityInfo).reduce(
      (acc, cur) => {
        acc[`${cur}Display`] =
        superuserServiceRole.managementFunctionAuthorityInfo[cur] > 0
            ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
            : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
        return acc;
      },
      {},
    );

    superuserServiceRole.managementFunctionAuthorityDisplayInfo = {
      ...authorityDisplayMapping,
    };
    const { managementFunctionAuthorityInfo, managementFunctionAuthorityDisplayInfo } = superuserServiceRole;

    return (
      <Modal
        className="modal-container"
        show={showModal}
        onHide={onAuthorityAboutOk}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={onAuthorityAboutOk} closeButton>
          <Modal.Title className="text-center">ロール設定</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col sm={12}>
            <Form className='form-horizontal'>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4} />
                  <Col sm={4}>画面表示</Col>
                  <Col sm={4}>権限設定</Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>ユーザー管理</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.userManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  {/* Step10.0.0 START */}
                  <Col sm={4}>ユーザーグループ設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.groupManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>コース</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.courseManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>ビデオ/ドキュメント/リンク/ドリル</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.contentManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>学習履歴</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.achievementManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>添削管理</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getScoringAuthorityText(managementFunctionAuthorityInfo.scoringManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>メッセージ管理</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getScoringAuthorityText(managementFunctionAuthorityInfo.messageManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>お知らせ</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.noticeManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>メール連絡</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.emailManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>ライブ</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.liveManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>受講ユーザー画面設定</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.userfrontManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>システム利用実績管理</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.performanceManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>ロール設定</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(managementFunctionAuthorityInfo.authorityManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>TOP画面ダウンロードボタン</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getMaterialAuthorityText(managementFunctionAuthorityInfo.materialManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
            </Form>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="primary" className="margin-10 btn-96" onClick={onAuthorityAboutOk}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AboutSuperuserServiceRoleDialog;
